module.exports = __webpack_public_path__ + "static/img/no-search.8efa3a97.png";